<template>
  <div class="main-links hidden">
    <div id="offer-direct-link" class="collapse">
      <a 
        class="btn btn-direct-link"
        v-for="category in categories"
        :href="categoryLink(category.slug)">
        <span>{{ category.name }}</span>
      </a>
    </div>
    <a
      class="btn btn-primary collapsed"
      data-toggle="collapse" 
      data-target="#offer-direct-link"
      aria-expanded="false"
      aria-controls="#offer-direct-link">
      <span class="show-plus"><i class="fas fa-plus-circle"></i>&nbsp;Mostra di più</span>
      &nbsp;
      <span class="show-minus"><i class="fas fa-minus-circle"></i>&nbsp;Mostra di meno</span>
    </a>
  </div>
</template>

<script>

export default {
  name: 'Links',
  created: function() {
    this.$root.$on('categories-loaded', function(data){
      let categories = [ 'Periodo', 'Tema' ];
      let i, j;
      for( i in categories ) {
        for( j in data[categories[i]] ) {
          this.categories.push(data[categories[i]][j]);
        }
      }
    }.bind(this));
  },
  mounted: function() {
    // eslint-disable-next-line
    // jQuery('#offer-direct-link', this.$el).on('shown.bs.collapse', function() {console.log(this);});
    // eslint-disable-next-line
    // jQuery('#offer-direct-link', this.$el).on('hidden.bs.collapse', function() {console.log(this);});
  },
  data: function() {
    return {
      categories: [],
    }
  },
  methods: {
    categoryLink: function(slug) {
      let url = [ '/vacanze-con-bambini/offerte-vacanze-famiglia/offerte' ];

      url.push(slug);
      url.push('');
      return url.join('/');
    }
  }
}
</script>